import React from "react";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { LoadingButton } from "@mui/lab";
import { ListPericiasByDatePDFDocument, ListPericiasByDatePDFProps } from "../api/useListPericiasByDateRangePDFCreator-react-pdf";

interface ListPericiasByDatePDFDownloadProps {
  props: ListPericiasByDatePDFProps;
  disabled?: boolean;
}

// Helper function to get label based on filter
const getFilterLabel = (filter: string): string => {
  switch (filter) {
    case "done":
      return "Macchine finite";
    case "notDone":
      return "Macchine in aperto";
    case "billed":
      return "Macchine fatturate";
    case "isPriceCalculated":
      return "Macchine controlate";
    default:
      return "Macchine";
  }
};

export const ListPericiasByDatePDFDownload: React.FC<ListPericiasByDatePDFDownloadProps> = ({ props, disabled = false }) => {
  const selectedPericiasLabel = getFilterLabel(props.filter);
  const fileName = `${selectedPericiasLabel}_pericias_${new Date().toLocaleDateString("pt-BR")}.pdf`;

  return (
    <PDFDownloadLink document={<ListPericiasByDatePDFDocument {...props} />} fileName={fileName}>
      {({ loading }: { loading: boolean }) => (
        <LoadingButton fullWidth variant="contained" sx={{ mb: 1, mt: 5 }} disabled={disabled || loading} loading={loading}>
          {loading ? "Gerando PDF..." : "GERAR PDF"}
        </LoadingButton>
      )}
    </PDFDownloadLink>
  );
};
